import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import type { SystemDocumentPageEntry } from 'features/knowledgeDocumentViewer/types/systemDocumentPageSchemas'
import type { SystemDocumentPageLoadOptions } from 'features/knowledgeDocumentViewer/utils/documentEntryLookups'
import { loadPageRevisionFamilyPages } from 'features/knowledgeDocumentViewer/utils/loadPageRevisionFamilyEntries'
import useSWR from 'swr'

export function usePageRevisionFamilyPages(
  options: SystemDocumentPageLoadOptions | undefined
) {
  const { authorizedAxios, isAuthenticated } = useGeckoAuth()
  const { ROLODEX_URL } = useRuntimeVariables()
  return useSWR<SystemDocumentPageEntry[], Error>(
    options && isAuthenticated
      ? [
          `${ROLODEX_URL}/api/v2/entries/load`,
          JSON.stringify(options),
          'all-family-pages',
        ]
      : null,
    () => {
      if (!options) throw new Error('Revision family page scope is required')
      return loadPageRevisionFamilyPages({
        axios: authorizedAxios,
        rolodexUrl: ROLODEX_URL,
        loadOptions: options,
      })
    },
    { keepPreviousData: false }
  )
}
